/**
 * Help command
 */
export default async function helpCommand(options, wasmFs) {
    console.log(options, wasmFs);
    return `help Command Working! Options: ${options}, fs: ${wasmFs}`;
}